import TableHasPagenation from '../../../components/TableHasPagenation'
import { Modal} from 'antd'
import { useState, useEffect } from 'react'
import service from '../../../@services'
import { Link } from 'react-router-dom'
const typeMap = {
  SALE_CANCEL: '销售退货',
  SALE_OK: '销售出库',
  CHECK_MORE: '盘盈入库',
  CHECK_LESS: '盘亏出库',
  PURCHAGE_CANCEL: '采购退货',
  PURCHAGE_OK: '采购入库',
  ALLOCATION_OUT: '调拨出库',
  ALLOCATION_IN: '调拨入库'
}
const wayTypeMap = {
  AUTO_IN: '自动入库',
  AUTO_OUT: '自动出库',
  COUNT_IN: '数量入库',
  COUNT_OUT: '数量出库'
}
const basicColoums = [
  {
    title: '类型',
    dataIndex: 'type',
    render: text => typeMap[text]
  },
  {
    title: '方式',
    dataIndex: 'wayType',
    render: text => wayTypeMap[text]
  },
  {
    title: '变动前数量',
    dataIndex: 'beforeStock'
  },
  {
    title: '变动数量',
    dataIndex: 'changeStock'
  },
  {
    title: '变动后数量',
    dataIndex: 'afterStock'
  },
  {
    title: '更新时间',
    dataIndex: 'createTime'
  }
]

export default function ProductInventoryTransition({
  skuId = '',
  storeCode = '',
  stockStoreType = '',
  isOnline,
  setSkuId,
  title = ''
}) {
  const [pageData, setPageData] = useState({
    pageIndex: 1,
    pageSize: 10,
    total: 0,
    result: []
  })
  const [loading, setLoading] = useState(false)
  const getList = (params = {}) => {
    if (loading) return Promise.reject()
    setLoading(true)
    return service.inventory
      .getStockHistoryBuSkuid({
        skuId,
        storeCode,
        stockStoreType,
        pageIndex: params.pageIndex || pageData.pageIndex,
        pageSize: params.pageSize || pageData.pageSize
      })
      .then(data => {
        setLoading(false)
        if (data) {
          setPageData(data)
        }
      })
      .catch(e => {
        setLoading(false)
        throw e
      })
  }
  const secondColumns = !isOnline
    ? [
        {
          title: '出入库单据',
          dataIndex: 'no',
          render: (text, record) => (
            ['PURCHAGE_OK', 'SALE_CANCEL', 'CHECK_MORE', 'ALLOCATION_IN'].includes(record.type)?
      <Link
        to={{
          pathname: '/inventory/stock-in/list',
          state: { no:  record.no, stockType:  record.type},
        }}
        style={{ color: '#3e9eff' }}
      >
        {record.no}
      </Link>
      :
      <Link
        to={{
          pathname: '/inventory/stock-out/list',
          state: { no:  record.no, stockType: record.type },
        }}
        style={{ color: '#3e9eff' }}
      >
        {record.no}
      </Link>
            )
        }
      ]
    :
    [
      {
        title: '流水号',
        dataIndex: 'no'
      }
    ]
  const columns = [
    {
      title: '序号',
      dataIndex: 'no',
      render: (text, record, index) =>
        (pageData.pageIndex - 1) * pageData.pageSize + (index + 1)
    },
    ...secondColumns,
    ...basicColoums
  ]
  useEffect(() => {
    getList()
    return () => {
      // setSkuId(null)
    }
  }, [skuId])
  return (
    <Modal
      width={800}
      title={title}
      footer={null}
      onCancel={() => setSkuId(null)}
      visible={!!skuId}>
      <TableHasPagenation
        rowKey='no'
        loading={loading}
        columns={columns}
        pageData={pageData}
        onPageSizeChange={getList}
      />
    </Modal>
  )
}
